(function(){
  var d=document.documentElement;
  /* pages whose first section is a scroll-story hero (About · reveal): header stays transparent at the very top,
     steps away while the hero plays and only comes back with its cream background once the hero is done */
  var hero,hq=false;
  function findHero(){if(hq)return hero;var m=document.querySelector('main'),f=m&&m.querySelector(':scope > .shopify-section');if(f){hq=document.readyState!=='loading';if(f.querySelector('.sb-ah--reveal'))hero=f;}return hero;}
  function u(){var y=window.scrollY,solid=y>24,away=false,h=findHero();
    var enter=false;if(h){var b=h.getBoundingClientRect().bottom;solid=b<=90;away=y>24&&!solid;enter=solid&&b>-window.innerHeight*.7;}
    d.classList.toggle('vh-solid',solid);d.classList.toggle('vh-away',away);d.classList.toggle('vh-enter',enter);}
  window.addEventListener('scroll',u,{passive:true});u();document.addEventListener('DOMContentLoaded',u);
  function split(){
    var menu=document.querySelector('.sb-hdr__bar .sb-hdr__menu'),icons=document.querySelector('.sb-hdr__icons');
    if(!menu||!icons||document.querySelector('.vh-right'))return;
    var items=[].slice.call(menu.children);
    function f(t){for(var i=0;i<items.length;i++){if(items[i].textContent.trim().toLowerCase()===t)return items[i];}}
    var right=document.createElement('ul');right.className='sb-hdr__menu vh-right';right.setAttribute('role','list');
    ['contact','blog'].forEach(function(t){var li=f(t);if(li)right.appendChild(li);});
    var fyb=f('find your blend');if(fyb)menu.appendChild(fyb);
    icons.insertBefore(right,icons.firstChild);
  }
  /* Shop (mega item): click goes to all products, the mega panel still opens on hover */
  function shopHref(li){
    var a=[].slice.call(li.querySelectorAll('.sb-mega__links a'));
    for(var i=0;i<a.length;i++){if(/\/collections\/all(-products)?\/?$/.test(a[i].pathname))return a[i].href;}
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';return root+'collections/all-products';
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('.sb-hdr__bar .sb-hdr__item--mega > button');if(!btn)return;
    var li=btn.parentElement;if(!/^(shop|winkel)$/i.test(btn.textContent.trim()))return;
    e.preventDefault();e.stopImmediatePropagation();window.location.href=shopHref(li);
  },true);
  /* mirror the drawer/mega open state onto the header section (replaces a costly :has selector) */
  function openSync(){var s=document.querySelector('.shopify-section.sb-hdr-section'),h=document.querySelector('.sb-hdr');if(!s||!h)return;
    var f=function(){s.classList.toggle('is-open-hdr',h.classList.contains('is-open'))};f();new MutationObserver(f).observe(h,{attributes:true,attributeFilter:['class']});}
  function init(){split();openSync();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
